<script>
  import { createEventDispatcher } from "svelte";
  import Modal from "../HTMLElements/Modal.svelte";
  export let showTooFewSchoolsWarning = true;
  export let selectedPreferences;
  export let maxPreference;
  const dispatch = new createEventDispatcher();

  const numToWords = number => {
    let numbers = [
      { number: 0, word: "ZERO" },
      { number: 1, word: "ONE" },
      { number: 2, word: "TWO" },
      { number: 3, word: "THREE" },
      { number: 4, word: "FOUR" },
      { number: 5, word: "FIVE" },
      { number: 6, word: "SIX" }
    ];
    return numbers.find(n => n.number == number);
  };
    let selectedPref = numToWords(selectedPreferences);
  let maxPref = numToWords(maxPreference);
</script>

<Modal
  bind:showModal={showTooFewSchoolsWarning}
  on:closed={() => {
    showTooFewSchoolsWarning = false;
  }}>
  <div class="section">
    <div class="field">

      <p>
        You have only applied for {selectedPref.word}
        {#if selectedPreferences == 1}school{:else}schools{/if}.You can apply for up to {maxPref.word} schools.
      </p>
      <ul>
        <li>
          Adding more schools will not affect the outcome at schools you prefer more
        </li>
        <li>
          Include schools at which your child is most likely to qualify for a
          place
        </li>
        <li>
          This makes it more likely that you will be offered a school on your list. 
        </li>
      </ul>

    </div>
  </div>
  <footer class="modal-card-foot buttons is-right" slot="footer">
    <a
      href="#"
      on:click|preventDefault={() => {
        showTooFewSchoolsWarning = false;
        dispatch('addSchool');
      }}
      class="button is-primary"
      style="margin-right:10px;">
      Add another school
    </a>
    <a
      href="#"
      on:click|preventDefault={() => {
        showTooFewSchoolsWarning = false;
        dispatch('continue');
      }}
      class="button is-purple"
      style="margin-right:10px;">
      Continue
    </a>
  </footer>

</Modal>
